<template>
    <widget :title="title" :router="router" :class="'widget_level'+widgetType">
        <div class="widget_cont">
            <div class="social_left" v-if="widgetType != 1">
                <div class="center_info">
                    <div class="item" @click="nodeSplicing({
                        node:'myDynamics',
                        otherParam:{selectMenu:0},
                        breadcrumb:'个人中心'
                    })">
                        <span>
                            <span class="float_right">{{tableData.myDynamics || 0}}</span><template v-if="widgetType == 2">我的</template>动态<template v-if="widgetType == 2">：</template>
                        </span>
                    </div>
                    <div class="item" @click="nodeSplicing({
                        node:'myAttention',
                        otherParam:{selectMenu:1},
                        breadcrumb:'个人中心'
                    })">
                        <span>
                            <span class="float_right">{{tableData.myAttention || 0}}</span><template v-if="widgetType == 2">我的</template>关注<template v-if="widgetType == 2">：</template>
                        </span>
                    </div>
                    <div class="item" @click="nodeSplicing({
                        node:'myFans',
                        otherParam:{selectMenu:3},
                        breadcrumb:'个人中心'
                    })">
                        <span>
                            <span class="float_right">{{tableData.myFans || 0}}</span><template v-if="widgetType == 2">我的</template>粉丝<template v-if="widgetType == 2">：</template>
                        </span>
                    </div>
                </div>
                <div class="recommend_title" v-if="widgetType == 3">名师推荐</div>
                <div class="recommend_info" v-if="widgetType == 3" :key="aa">
                    <div class="rec_item" v-for="(teacher,tIndex) in tableData.teacherRecommend" :key="tIndex">
                        <div class="user_img">
                            <img :src="imageUrl + teacher.accountAvatar" @error="errorImg($event,'avatar')">
                            <span>师</span>
                        </div>
                        <div class="user_name">{{teacher.userName}}</div>
                        <div class="add_friends" v-if="teacher.isFocuseded == 1">已关注</div>
                        <div class="add_friends" v-else @click="focused(teacher,1)">加关注</div>
                    </div>
                </div>
            </div>
            <div class="social_right">
                <div class="social_level1">
                    <div class="social_item" v-for="(list,index) in tableData.dynamicList" :key="index">
                        <img :src="imageUrl + list.accountAvatar" class="user_img" @error="errorImg($event,'avatar')">
                        <div class="social_cont">
                            <span class="user_name">{{list.userName}}</span>
                            <div @click="nodeSplicing({
                                node:'dynamicList,introducedText',
                                otherParam:{id:list.id},
                                breadcrumb:'个人中心'
                            })">{{list.introducedText}}</div>
                        </div>
                        <div class="social_files" @click="nodeSplicing({
                                node:'dynamicList,introducedText',
                                otherParam:{id:list.id},
                                breadcrumb:'个人中心'
                            })">

                            <img :src="imageUrl + list.cover" class="cover" v-if="list.cover">
                            <img src="@/img/default_image_small.png" class="cover" v-else>
                            
                            <img src="../img/widget/files.png" v-if="list.attachmentType == 0 && list.attachmentTypeNum > 1" class="is_files">
                            <img src="../img/widget/play.png" v-if="list.attachmentType == 1 || list.attachmentType == 2" class="is_video">
                        </div>
                    </div>
                </div>
                <div class="add_dynamic" v-if="widgetType == 1" @click="dtFn">发布动态</div>
            </div>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number
            },
            item:{
                type:Object
            }
        },
        data(){
            return {
                widgetType:1,
                router:'social_index',
                tableData:[],
                configList:null,
                imageUrl: window.systemParameter.FILE_SYSTEM_URL + "/api/image/thumbnail/",
                aa:1,
                widgetUrl:'/gateway/social/widget'
            }
        },
        activated(){
            this.query()
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                 vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    vm.widgetUrl = stemp[0].apiUrl
                    vm.query()
                }
            })
        },
        methods: {
            query(){
                let vm = this
                http.get(vm.widgetUrl).then(function(xhr){
                    let objectA = xhr.data
                    let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                    var newObj = new Object();
                    vm.tableData = widgetFilter.showProps(objectA,'',simpleMap,newObj)

                })
            },
            focused(item,type){
                let vm = this;
               
                let obj = {
                    payAttentionId: item.userId,
                    remark: "YHTJ",
                    userId: window.appframe.$store.state.userInfo.id
                }
                if(type === 1){
                    http.post(InterfacePrefix['social'] + '/focuseds', obj).then(function(xhr) {
                        if (xhr.data.code) return // 异常情况有公共处理
                        item.isFocuseded = 1
                        vm.aa = Math.random()
                    })
                }
            },
            dtFn(){
                this.$irouter({name: 'social_index'});
            },
            nodeSplicing(){
                let irouter = widgetFilter.nodeSplicing(arguments[0],this.configList,this.simpleMap)
                if(irouter)
                this.$irouter(irouter)
            },
        }
    }
</script>
<style scoped lang="less">
    .widget_cont{
        height: 280px;
        overflow: hidden;
    }
    .center_info{
        display: flex;
        .item{
            flex: 1;
            border-radius:6px;
            color:#fff;
            cursor: pointer;
        }
        .item:nth-child(1){
            background:linear-gradient(to right,#1865F0,#3BB7FB);
            background:-webkit-linear-gradient(to right,#1865F0,#3BB7FB);
            background:-o-linear-gradient(to right,#1865F0,#3BB7FB);
            background:-moz-linear-gradient(to right,#1865F0,#3BB7FB);
        }
        .item:nth-child(2){
            background:linear-gradient(to right,#02CDF2,#24EAA6);
            background:-webkit-linear-gradient(to right,#02CDF2,#24EAA6);
            background:-o-linear-gradient(to right,#02CDF2,#24EAA6);
            background:-moz-linear-gradient(to right,#02CDF2,#24EAA6);
        }
        .item:nth-child(3){
            background:linear-gradient(to right,#D234F4,#FF76B3);
            background:-webkit-linear-gradient(to right,#D234F4,#FF76B3);
            background:-o-linear-gradient(to right,#D234F4,#FF76B3);
            background:-moz-linear-gradient(to right,#D234F4,#FF76B3);
        }
    }
    .social_item{
        display: flex;
        border-bottom:1px dashed #E5E7EA;
        padding: 11px 0;
        .user_img{
            width: 36px;
            height: 36px;
            border-radius:50%;
            flex-shrink:0;
            margin-right:12px;
            margin-top:6px;
        }
        .social_cont{
            flex-grow: 1;
            padding-top: 6px;
            span{
                color:#4183fc;
            }
            div{
                overflow: hidden;
                height: 20px;
                line-height: 20px;
                margin-top: 2px;
                cursor: pointer;
                /* text-overflow:ellipsis;
                white-space: nowrap; */
            }
        }
        .social_files{
            height: 48px;
            width: 48px;
            position: relative;
            flex-shrink: 0;
            cursor: pointer;
            .cover{
                width: 100%;
                height: 100%;
            }
            .is_files{
                position: absolute;bottom: 5px;right: 5px;
                width: 12px;
            }
            .is_video{
                position: absolute;top: 8px;left: 8px;
                width: 32px;
            }
        }
    }
    .widget_level1{
        .social_level1{
            height: 220px;
            overflow: hidden;
        }
        .add_dynamic{
            border:1px solid #BFCBD9;
            border-radius: 3px;
            line-height: 34px;
            width: 120px;
            margin-top: 6px;
            margin: 0 auto;
            text-align: center;
            margin-top: 6px;
            cursor: pointer;
        }
    }
    .widget_level2{
        .center_info{
            margin: 10px 0 5px 0;
            .item{
                height: 60px;
                line-height:60px;
                text-align:center;
                font-size:14px;
                margin-right:16px;
                .float_right{
                    font-size: 26px;
                }
                &>span{
                    display: inline-block;
                }
            }
            .item:last-child{
                margin-right: 0;
            }
        }
    }
    .widget_level3{
        .widget_cont{
            display: flex;
        }
        .social_left{
            width: calc(~'33.33% - 20px');
        }
        .social_right{
            width: calc(~'66.66% - 20px');
            margin-left:40px;
        }
        .center_info{
            margin: 18px 0 16px 0;
            font-size: 12px;
            .item{
                height: 68px;
                text-align:center;
                font-size:14px;
                margin-right:16px;
                .float_right{
                    font-size: 20px;
                    display: block;
                    float: none;
                    margin-top: 12px;
                }
            }
            .item:last-child{
                margin-right: 0;
            }
        }
        .recommend_title{
            color: #999;
        }
        .recommend_info{
            display: flex;
            flex-wrap: wrap;
            .rec_item{
                width: 50%;
                margin:16px 0;
            }
            .user_name{
                height: 20px;
                margin-left: 48px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .user_img{
                width: 48px;
                height: 48px;
                position: relative;
                float: left;
                margin-right: 12px;
                img{
                    border-radius:50%;
                    width: 100%;
                    height: 100%;
                }
                span{
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    font-size: 12px;
                    text-align: center;
                    line-height: 18px;
                    background: #F7C11E;
                    color: #fff;
                    border:1px solid #fff;
                    position: absolute;bottom: -2px;right: -2px;
                }
            }
            .add_friends{
                border:1px solid #BFCBD9;
                border-radius: 3px;
                line-height: 20px;
                padding: 0 14px;
                display: inline-block;
                font-size: 12px;
                margin-top: 6px;
                cursor: pointer;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/social.vue